export enum PATHS {
  Oauth = "/oauth_callback",
  Login = "/login",
  Home = "/",
  ChangePassword = "/ChangePassword",
}
